import { useQuery, useQueryClient } from '@tanstack/react-query';
import { localStateKeys } from '../utils/reportviewutils';
import { getWorksheetReportTemplateConfig } from '../services/config/function';
import { worksheetReportTemplateConfigKeys } from '../services/config/key';
//import { getFindings } from '../services/report/function';
//import { findingKeys } from '../services/report/key';
//import { measurementKeys } from '../services/report/key';
import '../styles/main.css';

function Comment() {
  const queryClient = useQueryClient();
  const numBlocks = queryClient.getQueryData<number>(localStateKeys.maxBlocks);

  const { status : status, data : data, error: error } = useQuery({
    queryKey: worksheetReportTemplateConfigKeys.all,
    queryFn: getWorksheetReportTemplateConfig,
    staleTime: Infinity,
    meta: { numBlocks : numBlocks, numParams : 10 },
  })

  // event handler 


  // if (isPending) 
  if (status === 'pending') {
    return <span>Loading...</span>
  }

  // if (isError) 
  if (status === 'error') {
    return <span>Error: {error.message}</span>
  }

  return (
    <>
      { 
        (() => {
          data;
          console.log('edit and preview component is now rendering...');
          return null;
        })() && undefined
      }
      <section className="button-section">
      </section>
      <section>
        <h1>Comment</h1>
        <p className="read-the-docs">
          Footer part.
        </p>
      </section>
    </>
  )
}

export default Comment
